import { useMemo } from 'react';
import { components as reactSelectComponents } from 'react-select';
import Control from '../components/control';
import {
  renderInput,
  renderOption,
  renderPlaceholder,
  renderSingleValue,
} from '../component-renders';
import Menu from '../components/menu';
import MenuPortal from '../components/menu-portal';
import ClearButton from '../components/clear-button';
import ArrowButton from '../components/arrow-button';
import LoadingMessage from '../components/loading-message';
import Tag from '../components/tag';
import TagContent from '../components/tag-content';
import TagDeleteButton from '../components/tag-delete-button';
const useInternalComponents = (components, { withDropdownIndicator }) =>
  useMemo(
    () => ({
      Control,
      Input: renderInput(components?.Input),
      Menu,
      MenuPortal,
      Option: renderOption(components?.Option),
      SingleValue: renderSingleValue(components?.SingleValue),
      Placeholder: renderPlaceholder(components?.Placeholder),
      ValueContainer: components?.ValueContainer || reactSelectComponents.ValueContainer,
      ClearIndicator: ClearButton,
      DropdownIndicator: withDropdownIndicator ? ArrowButton : null,
      LoadingMessage,
      LoadingIndicator: components?.LoadingIndicator,
      IndicatorSeparator: null,
      MultiValueContainer: Tag,
      MultiValueLabel: TagContent,
      MultiValueRemove: TagDeleteButton,
    }),
    [
      components?.Input,
      components?.LoadingIndicator,
      components?.Option,
      components?.Placeholder,
      components?.SingleValue,
      components?.ValueContainer,
      withDropdownIndicator,
    ]
  );

export default useInternalComponents;
